import React from "react";
import { ApiFetch } from "../../../../../../config/api";
import { useAuthContextState } from "../../../../../../context/auth/authContext/authContextState";
import { FetchInterface, Method } from "../../../../../../enums/enum";
import BarChart from "../../../../../barChart/barChart";
import PersonalTableDashboard from "../../../../../personalTableDashboard/personalTableDashboard";

const Salary = React.forwardRef(function Salary({ salaryData, address ,filterDataName }, ref) {
  const [modalShow, setModalShow] = React.useState(false);
  const [disableFilter, setDisableFilter] = React.useState(false);
  const [tableDataForFilter, setTableDataForFilter] = React.useState({});
  const { token } = useAuthContextState();
  const [tableData, setTableData] = React.useState({
    header: "",
    data: [],
  });
  React.useImperativeHandle(ref, () => ({
    async getPersonalInfoAllCareerAndSalary() {
      setModalShow(true);
      setDisableFilter(false)
      const titleData = {
        title: null,
        filterDataName:!!filterDataName ? filterDataName : "",
        datasetTitle: null
      };
      try {
        const res = await ApiFetch({
          [FetchInterface.PATH]: `auth/career-personal-table-info/salaryRange/${address.provice}/${address.amphur}/${address.tambol}/${address.group}`,
          [FetchInterface.METHOD]: Method.GET,
          [FetchInterface.TOKEN]: token.accessToken,
          [FetchInterface.PARAMS]: titleData,
        });
        if (res.status === 200) {
          setTableDataForFilter(res.data);
          setTableData({
            header: { datasetTitle: "-", title: "ทุกช่วงรายได้" },
            data: res.data,
          });
        }
        // setLoading(false)
      } catch (error) {
        // setLoading(false)
        console.log(error);
      }
    },
  }));
  return (
    <>
      <div style={{ height: "40vh" }}>
        <BarChart
          setDisableFilter={setDisableFilter}
          data={salaryData}
          setTableDataForFilter={setTableDataForFilter}
          address={address}
          filterDataName={filterDataName}
          pathname={"career-personal-table-info"}
          section={"salaryRange"}
          setModalShow={setModalShow}
          setTableData={setTableData}
        />
      </div>
      <PersonalTableDashboard
        title={`ข้อมูลรายละเอียด ช่วงรายได้ ${tableData.header.title} ใน ${address.addressName} จำนวน ${tableData?.data?.data?.length} คน`}
        disableFilter={disableFilter}
        tableData={tableData}
        modalShow={modalShow}
        setModalShow={setModalShow}
        setTableData={setTableData}
        tableDataForFilter={tableDataForFilter}
      />
    </>
  );
});
export default Salary;
